/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for dashboard container;
 *   Integrations :01-02-2022
 *   Version : v1.0
 *   Created : 11-12-2021
 */

/*import packages*/
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

/*import components*/
import { SummaryDual } from '../../components/card/index';
import { LineChart, BarChartSecond } from '../../components/chart/index';
import SelectBox from '../../components/dropdown/selectBox';
import { EmptyNote, Toast } from '../../components/note';
import { Loader } from '../../components/loader';
import { DataTable } from '../../components/dataFormating/index';
import { Badge } from '../../components/badge';

/* import services */
import devconfig from '../../config/config';
import APIGet from '../../services/getApi';
// import APIPost from '../../services/postApi';


/*import assets*/
import Investors from '../../assets/images/card/investors.svg';
import TotalAum from '../../assets/images/card/total-aum.svg';
import PendingAum from '../../assets/images/card/pending-aum.svg';
import Investment from '../../assets/images/card/investment.svg';
import Goals from '../../assets/images/card/goals.svg';
import APIPost from '../../services/postApi';
// import DateRange from '../../components/input/dateRangepicker';

/* user-detail tab indices the activity feed deep-links into */
const SIP_TAB_INDEX = 5;
const MANDATE_TAB_INDEX = 7;
const ALL_TRANSACTIONS_TAB_INDEX = 9;

const ORDER_EVENT_TYPES = ['investment', 'investment_placed', 'redemption', 'redemption_placed', 'switch_order'];

/* maps each SIP/mandate event to the sub-tab status filter it should land on */
const SIP_STATUS_BY_EVENT = {
    sip_cancelled: 'cancelled',
    sip_cancel_3_failed_order: 'cancelled',
    sip_paused: 'paused',
    sip_resumed: 'active',
    sip_edited: 'active',
};
const MANDATE_STATUS_BY_EVENT = {
    bank_mandate_created: 'active',
    bank_mandate_cancelled: 'inactive',
};

const Index = (props) => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [selected, setSelected] = useState({ value: 2, label: 'Weekly', });
    const [dataLoader, setDataLoader] = useState(false);
    const [dashboardData, setDashboardData] = useState({});
    // const [staticsLabel, setStatisticsLabel] = useState([])
    const [cumulativeAumData, setCumulativeAumData] = useState([]);
    const [cumulativeUsersData, setCumulativeUsersData] = useState([]);
    const [loader, setLoader] = useState(false);
    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null)
    const [cumulativeAumLabel, setCumulativeAumLabel] = useState([]);
    const [investmentLoader, setInvestmentLoader] = useState(false);
    const [investmentAumData, setInvestmentAumData] = useState([]);
    const [investmentTotalData, setInvestmentTotalData] = useState([]);
    const [investmentAumLabel, setInvestmentAumLabel] = useState([]);
    const [investmentTotalLabel, setInvestmentTotalLabel] = useState([]);
    const [cronLoader, setCronLoader] = useState(false);
    const [cronData, setCronData] = useState([]);
    const [activityLoader, setActivityLoader] = useState(false);
    const [activityData, setActivityData] = useState([]);

    useEffect(() => {
        getDashboardData();
        getStatistics();
        getCronStatus();
        getActivityFeed();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setError(null);
        }, 300);
    }, [error]);

    useEffect(() => {
        getCumulativePerformace();
        //eslint-disable-next-line
    }, [selected])
    /* select box options ---*/

    const cumulativeOptions = [
        {
            value: 1, label: 'Daily',
        },
        {
            value: 2, label: 'Weekly'
        },
        {
            value: 3, label: 'Monthly'
        },
    ]


    /*----- dashboard data api ---*/
    const getDashboardData = () => {
        setDataLoader(true)
        let url = devconfig.admin + '/dashboard/get'
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                setDataLoader(false);
                setDashboardData(response.data);
            }
            else {
                setDataLoader(false);
                setError(response.message);
            }
        });
    }

    /*----- statistics api ---*/
    const getStatistics = () => {
        setInvestmentLoader(true);
        setInvestmentAumData([]);
        setInvestmentTotalData([]);
        setInvestmentAumLabel([]);
        setInvestmentTotalLabel([]);
        let url = devconfig.admin + '/dashboard/goal-statistics'
        let data = JSON.stringify({
            "filter_id": 1,
            "from_date": null,
            "till_date": null
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setInvestmentLoader(false);
                setInvestmentAumData(response.data.goal_aum.data);
                setInvestmentTotalData(response.data.goal_investment.data);
                setInvestmentAumLabel(response.data.goal_aum.label);
                setInvestmentTotalLabel(response.data.goal_investment.data);
            }
            else {
                setInvestmentLoader(false);
                setInvestmentAumData([]);
                setInvestmentTotalData([]);
                setInvestmentAumLabel([]);
                setInvestmentTotalLabel([]);
            }
        });
    }

    /*----- statistics api ---*/
    const getCumulativePerformace = () => {
        setCumulativeAumData([]);
        setCumulativeUsersData([]);
        setCumulativeAumLabel([])
        setLoader(true)
        let url = devconfig.admin + '/dashboard/cumulative-performance'

        let data = JSON.stringify({
            filter_id: selected.value,
            from_date: null,
            till_date: null
        })
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setLoader(false)
                setCumulativeAumData(Object.values(response.data.aum))
                setCumulativeAumLabel(response.data.aum.label)
                setCumulativeUsersData(Object.values(response.data.users))
            }
            else {
                setLoader(false)
                setCumulativeAumData([]);
                setCumulativeUsersData([]);
                setCumulativeAumLabel([]);
            }
        });
    }

    /*----- cron status api ---*/
    const getCronStatus = () => {
        setCronLoader(true);
        let url = devconfig.admin + '/dashboard/get-cron-status'
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                setCronLoader(false);
                setCronData(response.data || []);
            }
            else {
                setCronLoader(false);
                setCronData([]);
            }
        }).catch(() => {
            setCronLoader(false);
            setCronData([]);
        });
    }

    /*----- activity feed api ---*/
    const getActivityFeed = () => {
        setActivityLoader(true);
        let url = devconfig.admin + '/dashboard/activity-feed'
        let data = JSON.stringify({
            page_num: 1,
            page_size: 20
        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setActivityLoader(false);
                setActivityData(response.data.data ?? response.data);
            }
            else {
                setActivityLoader(false);
                setActivityData([]);
                setError(response.message);
            }
        });
    }

    /*----- format the pre-formatted "created" string down to mm/dd ---*/
    const _activityDate = (created) => {
        const parsed = moment(created, "DD MMM YYYY hh:mm A");
        return parsed.isValid() ? parsed.format("DD.MM.YYYY") : "--";
    }

    /*----- deep-link an activity feed row to the relevant screen ---*/
    const _handleActivityClick = (item) => {
        if (SIP_STATUS_BY_EVENT[item.event_type]) {
            navigate(`/user-detail?id=${item.user_id}&tab=${SIP_TAB_INDEX}&status=${SIP_STATUS_BY_EVENT[item.event_type]}`);
        }
        else if (MANDATE_STATUS_BY_EVENT[item.event_type]) {
            navigate(`/user-detail?id=${item.user_id}&tab=${MANDATE_TAB_INDEX}&status=${MANDATE_STATUS_BY_EVENT[item.event_type]}`);
        }
        else if (item.event_type === 'external_order') {
            navigate(`/user-detail?id=${item.user_id}&tab=${ALL_TRANSACTIONS_TAB_INDEX}`);
        }
        else if (ORDER_EVENT_TYPES.includes(item.event_type)) {
            navigate("/order-detail", {
                state: {
                    data: {
                        order_id: item.order_id,
                        is_ams: item.is_ams,
                        order_no: item.is_ams ? item.mira_order_id : null,
                        mira_order_id: item.mira_order_id,
                        customer_id: item.user_id,
                        created: item.created,
                        payment_status: null,
                        order_status: null,
                    },
                    user_id: item.user_id,
                    fName: item.customer_name,
                }
            });
        }
    }

    /*---- cron status table columns -----*/
    const cronColumns = [
        {
            name: 'Cron name',
            selector: (row) => row.cron_name ? row.cron_name : '--',
            sortable: true,
            left: true,
            minWidth: "250px",
        },

        {
            name: 'Status',
            selector: (row) => row.status,
            sortable: false,
            left: true,
            minWidth: "80px",
            cell: row => (
                row.status ?
                    <div className="d-inline-flex" >
                        <div className="col-lg-10">
                            <div className={
                                row.status === "Partially Success" ? `e-status-badge e-status-badge-partially` :
                                    row.status === "SUCCESS" ? `e-status-badge e-status-badge-success` :
                                        row.status === "FAILED" ? `e-status-badge e-status-badge-fail` :
                                            row.status === "Processing" ? `e-status-badge e-status-badge-pending` :
                                                'e-status-badge'
                            }>
                                {
                                    row.status
                                }

                            </div>
                        </div>
                    </div>
                    :
                    '-'
            )
        },
        {
            name: 'Update on',
            selector: (row) => row.last_updated ? row.last_updated : '--',
            sortable: true,
            left: true,
            minWidth: "150px",
        },
    ]

    /* Read a dashboard value with a safe fallback so empty responses show "-". */
    const _metric = (key) => {
        const value = dashboardData ? dashboardData[key] : undefined;
        return (value !== undefined && value !== null && value !== "") ? value : "-";
    };

    return (
        <>
            {
                !dataLoader ?
                    <>
                        {/*-------------- Dashboard cards---------------- */}

                        <div className="row e-dashboard">
                            {/* <div className="col-lg-3">
								<Summary 
								data={{ title: 'AUM', currency: "₹", count: dashboardData.aum_fee, icon: Transaction, text: "" }} 
								/>
							</div> */}
                            <div className="col-lg col-md-6 col-sm-6 mb-4">
                                <SummaryDual
                                    data={{
                                        title: 'Investors',
                                        icon: Investors,
                                        metrics: [
                                            { label: 'Active', value: _metric('active_investors') },
                                            { label: 'Pipeline', value: _metric('inactive_investors') },
                                        ],
                                    }}
                                />
                            </div>
                            <div className="col-lg col-md-6 col-sm-6 mb-4">
                                <SummaryDual
                                    data={{
                                        title: 'AUM',
                                        icon: TotalAum,
                                        metrics: [
                                            { label: 'Invested', value: _metric('aum') },
                                            { label: 'Processing', value: _metric('pending_transactions') },
                                        ],
                                    }}
                                />
                            </div>
                            <div className="col-lg col-md-6 col-sm-6 mb-4">
                                <SummaryDual
                                    data={{
                                        title: 'SIP',
                                        icon: Investment,
                                        metrics: [
                                            { label: 'Amount', value: _metric('total_sip_amount_text') },
                                            { label: 'Investors', value: _metric('sip_customer_count') },
                                        ],
                                    }}
                                />
                            </div>
                            <div className="col-lg col-md-6 col-sm-6 mb-4">
                                <SummaryDual
                                    data={{
                                        title: 'Withdrawals',
                                        icon: PendingAum,
                                        metrics: [
                                            { label: 'Withdrawn', value: _metric('total_withdraw_amount') },
                                            { label: 'Processing', value: _metric('pending_withdraw_amount') },
                                        ],
                                    }}
                                />
                            </div>
                            <div className="col-lg col-md-6 col-sm-6 mb-4">
                                <SummaryDual
                                    data={{
                                        title: 'Investments',
                                        icon: Goals,
                                        metrics: [
                                            { label: 'Invested', value: _metric('goals') },
                                            { label: 'Pending', value: _metric('pending_goals') },
                                        ],
                                    }}
                                />
                            </div>


                        </div>

                        {/*------------------ Activity feed------------------ */}
                        <div className="row mt-4">
                            <div className="col-lg-12">
                                <div className="card e-dashboard-card border-0 p-4">
                                    <h6 className="e-card-title mb-4">Activity Feed</h6>
                                    {
                                        activityLoader ?
                                            <Loader />
                                            : activityData.length > 0 ?
                                                <div className="e-activity-feed-list">
                                                    {
                                                        activityData.map((item) => (
                                                            <div
                                                                className="e-activity-feed-row"
                                                                key={item.activity_id}
                                                                onClick={() => _handleActivityClick(item)}
                                                            >
                                                                <span className="e-activity-feed-date">{_activityDate(item.created)}</span>
                                                                <span className="e-activity-feed-activity">{item.activity}</span>
                                                                <span className="e-activity-feed-text" title={item.text}>{item.text}</span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                :
                                                <EmptyNote note="No recent activity to show" />
                                    }
                                </div>
                            </div>
                        </div>

                        {/*------------------ Dashboard line graph------------------ */}

                        <div className="row mt-5 e-sort">
                            <div className='col-lg-6'>
                                <h6 className="e-card-setcion-title">Cumulative performance</h6>
                            </div>
                            <div className='col-lg-6 d-flex justify-content-end'>
                                {/* <DateRange

                                    onDatesChange={(start, end) => {
                                        setStartDate(start);
                                        setEndDate(end);
                                    }}
                                /> */}
                                <SelectBox
                                    value={selected}
                                    // isDisabled={startDate && endDate ? true : false}
                                    options={cumulativeOptions}
                                    className="e-dashboard-card-sort ms-3"
                                    selectchange={(temp) => { setSelected(temp); }}
                                    isSearchable={false}
                                />
                            </div>

                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-6 mb-lg-0 mb-md-4 mb-4">
                                <div className="card e-dashboard-card e-dashboard-row-2 e-round-chart-container border-0 p-4 ">
                                    <h6 className="e-card-title">AUM</h6>
                                    {
                                        !loader ?
                                            cumulativeAumData && cumulativeAumData.length > 0 && cumulativeAumLabel && cumulativeAumLabel.length > 0 ?
                                                <div className="col-lg-12 ms-3 e-w-800 ">
                                                    <LineChart
                                                        colors={['#106EE8', '#FFFFFF']}
                                                        data={cumulativeAumData[0]}
                                                        label={cumulativeAumLabel}
                                                    />
                                                </div>
                                                :
                                                <EmptyNote note="No data" />
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6 pe-0">
                                <div className="card e-dashboard-card e-dashboard-row-2 e-round-chart-container border-0 p-4">
                                    <h6 className="e-card-title">Users</h6>
                                    {!loader ?
                                        cumulativeUsersData && cumulativeUsersData.length > 0 ?
                                            <div className="col-lg-12 ms-3 e-w-800 ">
                                                <LineChart
                                                    colors={['#106EE8', '#FFFFFF']}
                                                    data={cumulativeUsersData[0]}
                                                    label={cumulativeUsersData[1]}
                                                    users={true}
                                                />
                                            </div>
                                            :
                                            <EmptyNote note="No data" />
                                        :
                                        null
                                    }
                                </div>
                            </div>

                        </div>

                        {/* -------- Dashboard Periodic performance bar graph--------------*/}

                        {/* <div className="d-flex justify-content-between mt-5 e-sort">
                            <h6 className="e-section-title">Cumulative Performance</h6>
                            <SelectBox
                                value={selectedPeriod}
                                options={periodicOptions}
                                defaultValue={periodicOptions[1]}
                                className="e-dashboard-card-sort"
                                selectchange={(temp) => { getPeriodicPerformance(temp.value); setSelectedPeriod(temp) }}
                                isSearchable={false}
                            />
                        </div> */}
                        <div className="row mt-4 e-bar-chart">

                            <div className="col-lg-12 mt-2 pe-0">
                                <div className="card e-dashboard-card e-dashboard-row-2 border-0 p-4 pe-0 pb-0" style={{ width: "100%" }}>
                                    <h6 className="e-card-title">Total investments</h6>
                                    {
                                        !investmentLoader ?
                                            investmentTotalData && investmentTotalData.length > 0 &&
                                                investmentTotalLabel && investmentTotalLabel.length > 0 ?
                                                <div className='ms-3 e-w-1600'>
                                                    <BarChartSecond
                                                        data={investmentTotalData}
                                                        label={investmentAumLabel}
                                                    />
                                                </div>

                                                :
                                                <EmptyNote note="No data" />
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="col-lg-12 mt-4 pe-0">
                                <div className="card e-dashboard-card e-dashboard-row-2 border-0 p-4 pb-0" style={{ width: "100%" }}>
                                    <h6 className="e-card-title">AUM</h6>
                                    {
                                        !investmentLoader ?
                                            investmentAumData && investmentAumData.length > 0 &&
                                                investmentAumLabel && investmentAumLabel.length > 0 ?
                                                <div className='ms-2 e-w-1600'>
                                                    <BarChartSecond
                                                        data={investmentAumData}
                                                        label={investmentAumLabel}
                                                    />
                                                </div>

                                                :
                                                <EmptyNote note="No data" />
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>

                        {/*------------------ Cron Status Table------------------ */}
                        <div className="row mt-4">
                            <div className="col-lg-12">
                                <div className="card e-dashboard-card border-0 p-4">
                                    <h6 className="e-card-title mb-4">Cron Status</h6>
                                    {
                                        !cronLoader ?
                                            (!cronData.length) ?
                                                <EmptyNote note="There are no cron jobs to show" />
                                                :
                                                <div className="col-lg-12 px-0">
                                                    <DataTable
                                                        pagination={false}
                                                        columns={cronColumns}
                                                        data={cronData}
                                                        perPage={10}
                                                        selectableRows={false}
                                                    />
                                                </div>
                                            :
                                            <Loader />
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <Loader />
            }

            {/* --------------- error message toast---------- */}
            {
                error !== null ?
                    <Toast
                        data={error}
                        id="1"
                        type="error"
                    />
                    :
                    null
            }
        </>
    );
}
export default Index;